import { render, staticRenderFns } from "./ProjectReportEmployeeDetails.vue?vue&type=template&id=7870f254"
import script from "./ProjectReportEmployeeDetails.vue?vue&type=script&lang=js"
export * from "./ProjectReportEmployeeDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports